import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app";

// Define a dashboard for the slice state
interface dashboardState {
  current_state: string;
}

// Define the initial state using that dashboard
const initialState: dashboardState = {
  current_state: "Access Control",
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  // `createSlice` will infer the state dashboard from the `initialState` argument
  initialState,
  reducers: {
    addDashboard: (state, action) => {
      return {
        ...state,
        current_state: action.payload,
      };
    },
  },
});

export const { addDashboard } = dashboardSlice.actions;

// Other code such as selectors can use the imported `RootState` dashboard
export const getDashboard = (state: RootState) => state.dashboard.current_state;

export default dashboardSlice.reducer;
